import { LEAVE_EVENT_MANAGEMENT_LABEL } from "./workspaceLabels";
import { WorkspaceLeaveControl } from "./WorkspaceLeaveControl";

type EventManagementBackControlProps = {
  onBack: () => void;
};

export function EventManagementBackControl({
  onBack,
}: EventManagementBackControlProps) {
  return (
    <WorkspaceLeaveControl label={LEAVE_EVENT_MANAGEMENT_LABEL} onBack={onBack} />
  );
}
